import type { CsvFlowAdapter } from '../../shared/csv/hooks/csvFlowAdapter';
import type { CatalogCsvEntityKind } from '../domain/csv/csvEntityKinds';
import {
  buildCatalogCsvExport,
  buildCatalogCsvTemplate,
} from '../infra/csv/catalogCsvExport';
import {
  catalogCsvExportFilename,
  catalogCsvTemplateFilename,
} from '../infra/csv/catalogCsvSchemas';
import { commitCatalogCsvImport, previewCatalogCsvImport, buildCatalogImportErrorsCsv } from '../infra/csv/catalogCsvImport';
import { syncCatalogSnapshotFromRemote } from '../infra/catalogSnapshotSync';

export function createCatalogCsvAdapter(
  entity: CatalogCsvEntityKind,
  maxProducts: number | null,
  performedByUserId: string | null,
  variantsEnabled: boolean = false,
): CsvFlowAdapter {
  return {
    buildTemplate: () => buildCatalogCsvTemplate(entity),
    templateFilename: () => catalogCsvTemplateFilename(entity),
    buildExport: () => buildCatalogCsvExport(entity),
    exportFilename: () => catalogCsvExportFilename(entity),
    previewImport: (text) => previewCatalogCsvImport(entity, text, { maxProducts }),
    commitImport: (text) => commitCatalogCsvImport(entity, text, { maxProducts, performedByUserId, variantsEnabled }),
    buildImportErrorsCsv: (errors) => buildCatalogImportErrorsCsv(errors),
    syncSnapshot: async () => {
      await syncCatalogSnapshotFromRemote({ force: true, forceFull: true });
    },
  };
}
